var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.984,
    height: 176.221,
    viewBox: "0 0 118.984 176.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#fcf9f9;}.c{fill:#4a4f60;}.d{fill:#eee;}.e,.o{fill:#d81212;}.f{fill:#f25555;}.g,.n{fill:#6d8aa2;}.h{fill:#99adbe;}.i{fill:#4caf50;stroke:#fff;stroke-width:2px;}.j{fill:#e8d1b3;}.j,.k,.l,.m,.n,.o,.p,.q,.r,.s{fill-rule:evenodd;}.k{fill:#16232c;}.l{fill:#adadad;}.m{fill:#dedede;}.p{fill:#ffd9c9;}.q{fill:#6f6571;}.r{fill:#d9d9d9;}.s{fill:#cbc7cb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-145.932 -63)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 100.501,
    height: 171.058,
    rx: 30,
    transform: "translate(155.156 65.582)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M342.487,7.5H327a10.325,10.325,0,0,1,10.325,10.326V168.235A10.325,10.325,0,0,1,327,178.56h15.489a10.325,10.325,0,0,0,10.325-10.326V17.827A10.325,10.325,0,0,0,342.486,7.5Z",
    transform: "translate(-97.154 58.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M225.365,17.825H192.853a5.163,5.163,0,0,1-4.617-2.854L184.5,7.5h49.218l-3.736,7.471a5.163,5.163,0,0,1-4.618,2.854Z",
    transform: "translate(-3.701 58.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M195.257,176.221h-79.85A12.921,12.921,0,0,1,102.5,163.314V12.907A12.921,12.921,0,0,1,115.407,0h79.85a12.921,12.921,0,0,1,12.907,12.907V163.314A12.921,12.921,0,0,1,195.257,176.221ZM115.407,5.163a7.753,7.753,0,0,0-7.744,7.744V163.314a7.753,7.753,0,0,0,7.744,7.744h79.85A7.753,7.753,0,0,0,203,163.314V12.907a7.753,7.753,0,0,0-7.744-7.744Z",
    transform: "translate(50.074 63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M152.334,169.5h23.783v10.532a11.909,11.909,0,1,1-23.817,0Zm47.6,0h23.783v10.532a11.909,11.909,0,1,1-23.817,0Z",
    transform: "translate(17.414 -59.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M148.376,169.5h23.783v10.532a11.909,11.909,0,1,1-23.817,0V169.5Zm-23.783,0v10.532c0,.207-.007.41-.017.613A11.909,11.909,0,0,1,110,191.635V169.5Zm85.908,0v22.141a11.911,11.911,0,0,1-14.542-11c-.01-.2-.017-.406-.017-.613V169.5Z",
    transform: "translate(45.156 -59.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M202.249,107.281,159.3,112.444l-76-5.163,9.077-22.933a2.014,2.014,0,0,1,2.59-1.141l11.694,4.455,8.785-5.163h18.1l11.235,5.163L152,82.5h18.07l12.025,5.163a10.61,10.61,0,0,1,14.6,5.589Z",
    transform: "translate(62.666 -2.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M152.334,154.5h23.783v10.532a11.909,11.909,0,0,1-23.817,0Zm47.6,0h23.783v10.532a11.909,11.909,0,1,1-23.817,0Z",
    transform: "translate(17.414 -49.579)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M367.581,107.281l-12.253,5.163-11.6-5.163-8.295-24.54L335.4,82.5h21.2a1.721,1.721,0,0,1,1.6,1.088Z",
    transform: "translate(-102.666 -2.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M221.5,107.281,224.185,82.5h18.448l2.685,24.781L232.2,112.444l-10.7-5.163Z",
    transform: "translate(-27.969 -2.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M115.447,82.5l-8.364,24.781-12.666,5.163L83.3,107.281l9.379-23.693a1.721,1.721,0,0,1,1.6-1.088Z",
    transform: "translate(62.666 -2.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M130.8,154.5h23.783v10.532a11.909,11.909,0,1,1-23.817,0V154.5Zm-47.566,0h23.783v10.532a11.909,11.909,0,1,1-23.817,0V154.5Zm95.166,0h23.783v10.532a11.909,11.909,0,0,1-23.817,0V154.5Z",
    transform: "translate(62.732 -49.579)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M9.466,19.042a3.108,3.108,0,0,0-4.5,0,3.108,3.108,0,0,0,0,4.5L11.4,29.974a2.919,2.919,0,0,0,2.251.965,2.919,2.919,0,0,0,2.251-.965L38.4,7.466a3.108,3.108,0,0,0,0-4.5,3.108,3.108,0,0,0-4.5,0L13.646,23.222Z",
    transform: "translate(190.146 137.857)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M22.508,47.016A22.369,22.369,0,0,0,45.016,24.508a3.215,3.215,0,1,0-6.431,0A15.921,15.921,0,0,1,22.508,40.585,15.921,15.921,0,0,1,6.431,24.508,15.921,15.921,0,0,1,22.508,8.431a16.332,16.332,0,0,1,5.466.965,3.345,3.345,0,0,0,4.18-1.929,3.345,3.345,0,0,0-1.929-4.18A21.616,21.616,0,0,0,22.508,2,22.369,22.369,0,0,0,0,24.508,22.369,22.369,0,0,0,22.508,47.016Z",
    transform: "translate(181.285 137.857)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M399.761,228.265h-17.74v6.163a2.774,2.774,0,0,0,2.766,2.768h6.381l3.806,1.923,4.787-1.923v-8.931Z",
    transform: "translate(-211.66 -28.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M397,162.742H384.788a2.774,2.774,0,0,0-2.766,2.768v4.579h17.74V165.51A2.774,2.774,0,0,0,397,162.742Z",
    transform: "translate(-211.66 28.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M399.762,206.463h-17.74v4.352h17.74Z",
    transform: "translate(-211.66 -9.313)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M235.97,293.7h-8.593v3.953a1.728,1.728,0,0,0,1.722,1.723h27.977c0-2.485,0-3.749-1.9-3.749l-3.786,0c-2.383,0-3.946-.614-4.819-1.923h-10.6Z",
    transform: "translate(-47.869 -84.644)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M169.2,335.289H144.6c-1.443,2.513-2.6,5.532-1.6,11.308,1.674-5.7,18.676-3.422,20.422,3.151h18.76c.709-1.607,1.379-3.2,1.965-4.8h-5.289C168.159,340.913,171.6,342.712,169.2,335.289Z",
    transform: "translate(36.629 -120.557)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M249.187,129.954a40.163,40.163,0,0,1-1.423,5.453l-5.408,2.119-6.03-2.119c.211-11.412,4.476-16.884,8.1-18.655a8.8,8.8,0,0,1,2.646-1.37s1.762,2.818,1.853,2.818a15.139,15.139,0,0,1,.889,5.983Z",
    transform: "translate(-41.836 69.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M208.376,262.108h11.439c2.635.287,5.875,2.294,5.875,8.508v6.514l-2.6,1.546-3.374-1.546V272.1c0-2.485,0-3.749-1.9-3.749l-3.786,0c-2.383,0-3.946-.614-4.818-1.923A7.059,7.059,0,0,1,208.376,262.108Z",
    transform: "translate(-13.887 -57.364)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M315.355,374.177a10.429,10.429,0,0,0-20.422-3.151,10.7,10.7,0,0,0-.458,2.816c-.012.383.251.335.61.335q10.133,0,20.27,0Z",
    transform: "translate(-115.305 -144.986)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M329.612,441.231H313.718a7.952,7.952,0,0,0,15.894,0Z",
    transform: "translate(-132.189 -212.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M30.342,428.81l-13.674,3.147a7.016,7.016,0,1,0,13.674-3.147Z",
    transform: "translate(207.443 -201.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M17.4,374.533a9.544,9.544,0,0,0-8.8-4.092c-6.186,1.308-8.2,5.006-8.6,9.617a9.531,9.531,0,0,0,.211,1.887c.04.176.155.1.347.06l2.14-.491,13.674-3.147,1.024-.235,1.431-.331A9.469,9.469,0,0,0,17.4,374.533Z",
    transform: "translate(221.412 -150.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M87.436,242.647l-5.524-19.114-2.487-1.113-2.782,1.113c3.655,10.131,2.635,17.2.167,23.953-.59,1.6-1.259,3.191-1.965,4.8h3.974Z",
    transform: "translate(142.59 -23.093)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M206.1,64.814l-6.481-1.38c-.658.06-2.539,1.639-2.539,2.629l1.379,7.012a6.329,6.329,0,0,0,1.813.267,6.266,6.266,0,0,0,5.827-8.528Z",
    transform: "translate(6.816 114.195)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M200.632,22.492a7.893,7.893,0,1,0-15.783,0,8.445,8.445,0,0,0,3.364,7.08,7.528,7.528,0,0,0,2.686,1.181V23.741c0-.989.5-1.189,1.16-1.249h8.573Z",
    transform: "translate(14.379 156.516)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M187.279,372.171h-5.97v3.761c0,.806.438.866,1.084.866h8.569C191.133,373.025,188.849,372.171,187.279,372.171Z",
    transform: "translate(24.523 -152.405)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M103.443,184.811l-7.457,2.465c-.367.327.048,3.662.295,3.554h8.669v-5.488C104.95,184.261,104.388,184.5,103.443,184.811Z",
    transform: "translate(122.209 9.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M149.26,206.321h3.77c2.025,0,2.084-3.359-.295-3.554l-3.475-.279-.933,1.974Z",
    transform: "translate(65.463 -5.881)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M192.934,167.87l-1.247-1.073c-3.125-2.692-7.074,1.851-2.9,4.563l3.515,2.282,1.77,1.149h5.6v-3.833l-3.479-.283Z",
    transform: "translate(15.047 25.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M238.536,219.771Z",
    transform: "translate(-31.184 -20.479)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus9);
export default __webpack_public_path__ + "static/media/status-9.34d13ac1dd9a3d2af184c27bc6f863cf.svg";
export { ForwardRef as ReactComponent };